<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="headingPlant">Modify Outbound Weight</md-dialog-title>
      <md-dialog-content>
        <form id="top" novalidate @submit.prevent="doSaveUser">
          <div class="layoutScale layoutScale">
            <div >
              <callingApiCenter class= "adjust"
                type="bar"
                :paths="['/api/w/fsi/WebSaveOutbound']"
              ></callingApiCenter>
            </div>
          </div>
          <div class="main">
            <div class="layoutPlant">YG Weight-Tare  <md-field><md-input v-model="item.twYgWeight"/></md-field></div> 
            <div class="layoutPlant">Tare Weight range 13000 ~ 35000<md-field><md-input v-model="item.tareWeight"/></md-field></div>

            <div class="layoutPlant">YG Weight-Gross <md-field><md-input v-model="item.gwYgWeight"/></md-field></div> 
            <div class="layoutPlant">Gross Weight range 60000 ~ 78000<md-field><md-input v-model="item.vgmWeight"/></md-field></div>

            <div class="layoutPlant">Net Weight range 30000 ~ 50000<md-field><md-input v-model="item.weight" disabled /></md-field></div> 

            <div class="btngroup">
                  <md-button class="md-raised" @click="closeAction"
                    ><span class="icons-center material-icons">cancel</span
                    >Cancel</md-button
                  >
                  <md-button type="submit" class="md-raised md-primary"
                    ><span class="icons-center material-icons">create</span
                    >Save</md-button
                  >
            </div>      
          </div> 
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
@import "../../public/chrisForm.css";


.layoutPlant {
  width: 50%;
  /* line-height: 1; */
  color: rgb(155, 13, 13);
  display: inline-block;
  font-family: Roboto Slab;
  /*margin: auto;*/
  font-size: 18px;
  /* border: 1px; */
  /* margin-right: 5px; */
}


.adjust{
  padding-top: 0;
  margin-top: 0;
}

.headingPlant {
  /* padding-top: 10px; */
  padding-left: 12px;
  /* margin-bottom: 0px; */
  color: rgb(4, 4, 100);
  /* width: 92%; */
  /* line-height: 3; */
  font-size: 30px;
  font-family: Roboto Slab;
  /* margin-left: 35px; */
}




.btngroup {
  margin-left: 400px;
  /* margin-top: 30px; */
}

.main {
  width: 700px;
  /* margin-left: 30px; */
}


</style>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import api from "../api";
import { newAPIPost } from "../api/index.js";
import DatePickerBackdate from "./DatePickerBackDate.vue";
import callingApiCenter from "./CallingApiCenter.vue";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";


const getInitialdataForm = () => ({
  twYgWeight: null,
  tareWeight: null,
  gwYgWeight: null,
  vgmWeight: null,
  weight: null,
});
        
const getInitItem = () => ({

});

export default {
  components: {callingApiCenter, AutocompleteCcicLocationSelect,AutocompleteSelect},
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    item: getInitItem(),
  }),

  watch: {
    "item.twYgWeight"() {
      const gross = Number(this.item.vgmWeight == null ? "0" : this.item.vgmWeight) - Number(this.item.gwYgWeight == null ? "0" :this.item.gwYgWeight);
      const tare = Number(this.item.tareWeight) - Number(this.item.twYgWeight); 
      this.item.weight = (gross - tare).toString();  
    },

    "item.tareWeight"() {
      const gross = Number(this.item.vgmWeight == null ? "0" : this.item.vgmWeight) - Number(this.item.gwYgWeight == null ? "0" :this.item.gwYgWeight);
      const tare = Number(this.item.tareWeight) - Number(this.item.twYgWeight); 
      this.item.weight = (gross - tare).toString(); 
    },

    "item.gwYgWeight"() {
      const gross = Number(this.item.vgmWeight == null ? "0" : this.item.vgmWeight) - Number(this.item.gwYgWeight == null ? "0" :this.item.gwYgWeight);
      const tare = Number(this.item.tareWeight) - Number(this.item.twYgWeight); 
      this.item.weight = (gross - tare).toString(); 
    },

    "item.vgmWeight"() {
      const gross = Number(this.item.vgmWeight == null ? "0" : this.item.vgmWeight) - Number(this.item.gwYgWeight == null ? "0" :this.item.gwYgWeight);
      const tare = Number(this.item.tareWeight) - Number(this.item.twYgWeight); 
      this.item.weight = (gross - tare).toString(); 
    },



  },

  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getMasterDataAsSelectOptionByGroup",
      "getUserProfile",
    ]),
  },

  mounted() {

  },

  validations: {
    dataForm: {

    },
  },

  methods: {
    openDialog(existingUser) {  
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.item = existingUser;
      this.load = existingUser;
      this.showDialog = true;
    },

    closeAction() {
      this.showDialog = false;
    },


    async doSaveUser() {

      if (this.item.twYgWeight == null || this.item.twYgWeight == ""
      || this.item.tareWeight == null || this.item.tareWeight == ""
      || this.item.gwYgWeight == null || this.item.gwYgWeight == ""
      || this.item.vgmWeight == null || this.item.vgmWeight == ""
      || this.item.weight == null || this.item.weight == ""){
        window.confirm('All weights are required!')
            return;
      };

      if ( this.item.weight < 30000 || this.item.weight > 50000 || this.item.weight == "" || this.item.weight == null || this.item.weight == "NaN")
      {
        window.confirm('Net Weight Range must with 30000 ~ 50000')
            return;
      }

      this.$v.dataForm.$touch();
      console.log(JSON.stringify(this.dataForm));

      if (this.$v.dataForm.$invalid) {
        return;
      }
      

      if (this.mode == "LIST") {
        this.load.twYgWeight = this.item.twYgWeight;
        this.load.tareWeight = this.item.tareWeight;
        this.load.gwYgWeight = this.item.gwYgWeight;
        this.load.vgmWeight = this.item.vgmWeight;
        this.load.weight = this.item.weight;
        const seqNo = this.load.seqNo
        //api
        //  .post("/api/w/fsi/WebSaveOutbound", {
        newAPIPost("/api/w/fsi/WebSaveOutbound", {
            mode: "LIST",
            user: this.load.user,
            username: this.getUserProfile.username,
            seqNo: seqNo,
            twYgWeight: this.item.twYgWeight,
            tareWeight: this.item.tareWeight,
            gwYgWeight: this.item.gwYgWeight,
            vgmWeight: this.item.vgmWeight,
            weight: this.item.weight,
          })
          .then((list) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(seqNo, list, this.mode);
          });
      }
    },
  },
};
</script>
